import { useSearchParams } from "react-router-dom";
import { CheckCircle2, School, User, GraduationCap, Calendar, Hash, Briefcase } from "lucide-react";

const APP_LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_edu-censo-admin/artifacts/8c23fucn_Logo%20Censo911.png";

export default function Verificar() {
  const [sp] = useSearchParams();
  const tipo = (sp.get("tipo") || "alumno").toLowerCase();
  const nombre = sp.get("n") || "";
  const grado = sp.get("g") || "";
  const grupo = sp.get("gr") || "";
  const puesto = sp.get("p") || "";
  const ciclo = sp.get("c") || "";
  const cct = sp.get("cct") || "";
  const plantel = sp.get("pl") || "";
  const folio = sp.get("f") || "";

  const isAlumno = tipo === "alumno";
  const hasData = !!(nombre || folio);

  return (
    <div className="min-h-screen bg-[#F3F4F6] flex items-center justify-center p-4" style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <div className="w-full max-w-md">
        {/* Encabezado */}
        <div className="text-center mb-5">
          <img src={APP_LOGO} alt="Censo 911" className="w-14 h-14 object-contain bg-white rounded-lg p-1 mx-auto shadow-sm" crossOrigin="anonymous" />
          <div className="mt-2 text-[11px] tracking-[0.2em] uppercase text-[#6B7280]">Sistema Censo 911 · Tamaulipas</div>
          <div className="text-[10px] text-[#9CA3AF] mt-0.5">Verificación pública de credencial</div>
        </div>

        {!hasData ? (
          <div className="bg-white border border-[#E5E7EB] rounded-xl p-6 text-center">
            <div className="text-[#9F2241] font-semibold text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>Credencial no reconocida</div>
            <p className="text-sm text-[#6B7280] mt-1">El código escaneado no contiene información válida.</p>
          </div>
        ) : (
          <div className="bg-white border border-[#E5E7EB] rounded-xl overflow-hidden shadow-sm" data-testid="verificar-card">
            {/* Header */}
            <div className="bg-[#10312B] text-white px-5 py-3 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                {isAlumno ? <GraduationCap className="w-5 h-5" /> : <Briefcase className="w-5 h-5" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[10px] tracking-widest uppercase text-white/60">Credencial</div>
                <div className="text-sm font-semibold" style={{ fontFamily: "'Montserrat', sans-serif" }}>{isAlumno ? "Alumno" : "Docente / Personal"}</div>
              </div>
              <CheckCircle2 className="w-5 h-5 text-[#BC955C]" title="Formato válido" />
            </div>

            {/* Body */}
            <div className="p-5 space-y-3">
              <Field icon={User} label="Nombre" value={nombre} big />
              {isAlumno ? (
                <Field icon={GraduationCap} label="Grado y grupo" value={grado ? `${grado}° "${grupo || "—"}"` : "—"} />
              ) : (
                puesto && <Field icon={Briefcase} label="Puesto" value={puesto} />
              )}
              <Field icon={Calendar} label="Ciclo escolar" value={ciclo || "—"} />
              <Field icon={School} label="Plantel" value={plantel || "—"} />
              {cct && <Field icon={Hash} label="CCT" value={cct} mono />}
              {folio && <Field icon={Hash} label="Folio" value={folio} mono />}
            </div>

            {/* Footer */}
            <div className="border-t border-[#F3F4F6] bg-[#FAFAFA] px-5 py-3 text-[11px] text-[#6B7280] leading-relaxed">
              Esta vista muestra únicamente los datos codificados en el código QR de la credencial. No implica validación en línea contra la base de datos.
            </div>
          </div>
        )}

        <div className="text-center mt-4 text-[10px] text-[#9CA3AF]">
          &copy; {new Date().getFullYear()} Censo 911 · Tamaulipas
        </div>
      </div>
    </div>
  );
}

function Field({ icon: Icon, label, value, big, mono }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 rounded-full bg-[#EAECEE] flex items-center justify-center shrink-0 mt-0.5">
        <Icon className="w-4 h-4 text-[#10312B]" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-widest text-[#6B7280]">{label}</div>
        <div className={`${big ? "text-base font-semibold uppercase" : "text-sm"} ${mono ? "font-mono" : ""} text-[#111827] break-words`}>
          {value || "—"}
        </div>
      </div>
    </div>
  );
}
